/**
 * Same style as detail panels: e.g. "May 10, 2026, 5:12 AM" (follows browser locale).
 */
export function formatAdminDateTime(value) {
    if (value == null || value === "") return "—";
    const d = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(d.getTime())) return String(value);
    return d.toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
}
